import { isFunction, isString } from "lodash";
import { BADGE_ID_MAPPER } from '@/datas/auto-expire-badge';

function showResolvedDialog(resolvedComponent, props, events = {}) {
  if (resolvedComponent && resolvedComponent.default && window.Vue) {
    const tpl = window.Vue.extend(resolvedComponent.default);
    const vm = new tpl({
      propsData: Object.assign(props, { visible: true }),
    });
    Object.keys(events).forEach(eventName => {
      const eventHandler = events[eventName];
      if (isFunction(eventHandler)) {
        vm.$on(eventName, eventHandler);
      }
    });
    const el = vm.$mount().$el;

    // event
    vm.$on('closed', () => {
      document.body.removeChild(el);
      vm.$destroy();
      if (isFunction(events?.onClose)) {
        events.onClose()
      }
    });

    document.body.appendChild(el);
    return true;
  } else {
    return false;
  }
}
/**
 *
 * @param {Object} component: The component exported in @/components/index.js, or dynamically import
 * @param {Object} props: The props pass to component
 * @description Provide a function for caller to show a dialog easily.
 * Please Note:
 * 1. Emit 'closed' event after dialog closed
 */
export function showDialog(component, props = { visible: true }, events = {}) {
  return new Promise((resolve) => {
    if (typeof component === 'function' && window.Vue) {
      component().then((resolvedComponent) => {
        resolve(showResolvedDialog(resolvedComponent, props, events))
      });
    } else if (typeof component === 'object' && component.default) {
      resolve(showResolvedDialog(component, props, events))
    } else {
      resolve(false);
    }
  })
}

function doMount(resolvedComponent, rootId, props, events) {
  console.assert(rootId && isString(rootId) && document.getElementById(rootId), 'invalid root id', rootId)
  if (rootId && isString(rootId) && document.getElementById(rootId)) {
    const tpl = window.Vue.extend(resolvedComponent.default);
    const vm = new tpl({
      propsData: Object.assign(props),
    });
    Object.keys(events).forEach(eventName => {
      const eventHandler = events[eventName];
      if (isFunction(eventHandler)) {
        vm.$on(eventName, eventHandler);
      }
    });
    vm.$mount("#" + rootId)
    return vm;
  }
}
export function mountVueComponet(component, rootId, props = {}, events = {}) {
  return new Promise((resolve) => {
    if (typeof component === 'function' && window.Vue) {
      component().then((resolvedComponent) => {
        resolve(doMount(resolvedComponent, rootId, props, events))
      });
    } else if (typeof component === 'object' && component.default) {
      resolve(doMount(component, rootId, props, events))
    } else {
      resolve(false);
    }
  })
}

window.__ZM_BILLING_SHARED = Object.assign(window.__ZM_BILLING_SHARED || {}, {
  utils: {
    showDialog,
    mountVueComponet,
  },
  constants: {
    AUTO_EXPIRE_BADGE: { BADGE_ID_MAPPER }
  }
});
